import api from "./api";

export const login = (credentials) => api.post('/auth/login', credentials);
export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};
